
import React from 'react';
import {HistogramChart} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';

class BubbleSample extends React.Component {
    render() {
        const {dataNames} = this.props;
        //const dataObjectParsed = this.props.dataObject ? JSON.parse(this.props.dataObject.replace(/(\r\n|\n|\r|\s)/gm,"")) : []
        let finalObjectFiltered = []
        let finalNameFiltered = []

        this.props.dataObject.forEach((input, index) => {
            if (this.props.positionFilter.indexOf(index) > -1) {
                finalObjectFiltered.push(input)
                finalNameFiltered.push(dataNames[`positionname${index+1}`])
            }
        })
        console.log(this.props.dataObject)
        return (
            <div>
                <h2><strong>Results</strong></h2>
                {finalObjectFiltered.map((element, index)=>{
                    return (
                        <div>
                            <h2>{finalNameFiltered[index]}</h2>
                            <HistogramChart index={`index${index}`} data={element}/>
                        </div>
                    )
                })}
                
            </div>
        );
    }
}

export default BubbleSample;


// WEBPACK FOOTER //
// ./src/samples/run/histogramrun.js